const setAdminDetails = data => ({
  type: "SET_ADMIN_DETAILS",
  data
});

export const mutation = {
  setAdminDetails
};
